<template>
  <div>
    <div class="col-lg-2">
      <base-button
        style="font-size: 18px"
        @click="getBack()"
        class="btn-link btn-primary"
      >
        &lt; Back
      </base-button>
    </div>
    <div class="row d-flex justify-content-center">
      <div class="col-md-12">
        <simple-wizard ref="tabs" :indextghrunning="huhuhaha" :totalstep="hoi">
          <template slot="header">
            <h2 class="card-title"></h2>
            <h3 class="description"></h3>
          </template>

          <wizard-tab
            :activeTabIndex="activeTabIndex"
            :before-change="() => validateStep('step1')"
            v-if="flag"
          >
            <template slot="label">
              1
              
              <p style="color: #A5A5A5; width: 200px" v-if="landvesselflag == 'VESSEL'">ANF</p>
              <p style="color: #A5A5A5; width: 200px" v-if="landvesselflag == 'LAND'">WCO</p>

            </template>
            <first-step
           
              @my-event="myFunction"
              ref="step1"
              @on-validated="onStepValidated"
            ></first-step>
          </wizard-tab>

          <wizard-tab
            :activeTabIndex="activeTabIndex"
            :before-change="() => validateStep('step2')"
            
          >
            <template slot="label">
              2
              <p style="color: #A5A5A5; width: 200px">Quotation</p>
            </template>
            <second-step
             :key="componentKey"
              @my-event="myFunction"
              ref="step2"
              @on-validated="onStepValidated"
            ></second-step>
          </wizard-tab>

          <wizard-tab
            :before-change="() => validateStep('step3')"
            :activeTabIndex="activeTabIndex"
          >
            <template slot="label">
              3
              <p style="color: #A5A5A5; width: 200px">PTW</p>
            </template>
            <third-step
              @my-event="myFunction"
              ref="step3"
              @on-validated="onStepValidated"
            ></third-step>
          </wizard-tab>

          <wizard-tab
            :before-change="() => validateStep('step4')"
            :activeTabIndex="activeTabIndex"
            v-if="flag"
          >
            <template slot="label">
              4 
              <p style="color: #A5A5A5; width: 200px" v-if="landvesselflag == 'VESSEL'">WDR </p>
              <p style="color: #A5A5A5; width: 200px" v-if="landvesselflag == 'LAND'">WDO</p>

              
            </template>
            <fourth-step
              @my-event="myFunction"
              ref="step4"
              @on-validated="onStepValidated"
            ></fourth-step>
          </wizard-tab>

          <wizard-tab
            :before-change="() => validateStep('step5')"
            :activeTabIndex="activeTabIndex"
          >
            <template slot="label">
              5
              <p style="color: #A5A5A5; width: 200px">Invoice</p>
            </template>
            <fifth-step
              @my-event="myFunction"
              ref="step5"
              @on-validated="onStepValidated"
            ></fifth-step>
          </wizard-tab>

          <!-- <wizard-tab
            :before-change="() => validateStep('step6')"
            :activeTabIndex="activeTabIndex"
          >
            <template slot="label">
              6
              <p style="color: #A5A5A5; width: 200px">Invoice</p>
            </template>
            <sixth-step
              @my-event="myFunction"
              ref="step6"
              @on-validated="onStepValidated"
            ></sixth-step>
          </wizard-tab> -->
        </simple-wizard>
      </div>
    </div>
  </div>
</template>
<script>
import FirstStep from "../../Admin/Incoming/JobPage/ANF.vue";
import SecondStep from "../../Admin/Incoming/JobPage/Quotation.vue";
import ThirdStep from "../../Admin/Incoming/JobPage/PTW.vue";
// import FourthStep from "../../Admin/Incoming/JobPage/CollectionSchedule.vue";
import FourthStep from "../../Admin/Incoming/JobPage/WDR.vue";

import FifthStep from "../../Admin/Incoming/JobPage/Invoice.vue";
// import SixthStep from "../../Admin/Incoming/JobPage/Invoice.vue";
import swal from "sweetalert2";
import { SimpleWizard, WizardTab } from "src/components";


export default {
  data() {
    return {
      componentKey: 0,
      wizardModel: {},
      activeTabIndex: 0,
      jobstatus: "",
      landvesselflag: "VESSEL",
      huhuhaha: 0,
      hoi: 0,
      flag: true
    };
  },
  components: {
    FirstStep,
    SecondStep,
    ThirdStep,
    FourthStep,
    FifthStep,
    // SixthStep,
    SimpleWizard,
    WizardTab,
  },
  created() {
    this.flag = false
    this.getDetail(this.$route.params.jobnum.split("_")[0]);
  },
  methods: {
    forceRerender() {

      this.componentKey += 1;
      console.log("rerender: ", this.componentKey)
      this.getDetail(this.$route.params.jobnum.split("_")[0]);
    },
    getDetail(refNo) {
      this.$http.get(":10001/api/v1/incoming/" + refNo).then((res) => {
        if (!res.error) {
          let response = res.message;
          console.log(response);
          this.landvesselflag = response.company.company_type.toUpperCase();
          // this.huhuhaha = response.step;
          // this.hoi = 5;
          this.flag = true
        }
      });
    },
    myFunction(e) {
      console.log("panggil")
      this.flag = false
      let index = parseInt(e.step);
      // this.huhuhaha = index;
      this.hoi = 5;
      console.log("e", e)
      console.log(e.direction)

      if (e.direction == "depan") {
        // bila step 1, dia kan move ke step 2
        if (e.step == "0") {
          // active = content of child
          // checked = bullet tab
          // display quotation page

          
          setTimeout(() => {
            this.$refs.tabs.tabs[this.hoi - 1].active = false;
            this.$refs.tabs.tabs[this.hoi - 1].checked = false;
            this.$refs.tabs.tabs[this.hoi - 2].active = false;
            this.$refs.tabs.tabs[this.hoi - 2].checked = false;
            this.$refs.tabs.tabs[this.hoi - 3].active = false;
            this.$refs.tabs.tabs[this.hoi - 3].checked = false;
            this.$refs.tabs.tabs[this.hoi - 4].active = false;
            this.$refs.tabs.tabs[this.hoi - 4].checked = false;
            this.$refs.tabs.tabs[this.hoi - 5].active = true;
            this.$refs.tabs.tabs[this.hoi - 5].checked = true;
            this.huhuhaha = 1;
          }, 100);

          this.$emit(
            "tab-change",
            this.$refs.tabs.tabs[index - 1],
            this.$refs.tabs.tabs[index]
          );

          this.$emit("update:startIndex", index);
        }
        if (e.step == "1") {
          // active = content of child
          // checked = bullet tab
          // display quotation page

          
          setTimeout(() => {
            this.$refs.tabs.tabs[this.hoi - 1].active = false;
            this.$refs.tabs.tabs[this.hoi - 1].checked = false;
            this.$refs.tabs.tabs[this.hoi - 2].active = false;
            this.$refs.tabs.tabs[this.hoi - 2].checked = false;
            this.$refs.tabs.tabs[this.hoi - 3].active = false;
            this.$refs.tabs.tabs[this.hoi - 3].checked = false;
            this.$refs.tabs.tabs[this.hoi - 4].active = true;
            this.$refs.tabs.tabs[this.hoi - 4].checked = true;
            this.$refs.tabs.tabs[this.hoi - 5].active = false;
            this.$refs.tabs.tabs[this.hoi - 5].checked = true;
            this.huhuhaha = 2;
          }, 100);

          this.$emit(
            "tab-change",
            this.$refs.tabs.tabs[index - 1],
            this.$refs.tabs.tabs[index]
          );

          this.$emit("update:startIndex", index);
        }

        if (e.step == "2") {
          console.log("masuk 2")
          // display ptw page
          // this.$refs.tabs.tabs[index].active = true;
          // this.$refs.tabs.tabs[index].checked = true;
          setTimeout(() => {
            // this.$refs.tabs.tabs[index - 1].active = false;
            // this.$refs.tabs.tabs[index - 1].checked = true;
            // this.$refs.tabs.tabs[index - 2].active = false;
            // this.$refs.tabs.tabs[index - 2].checked = true;
            this.$refs.tabs.tabs[this.hoi - 1].active = false;
            this.$refs.tabs.tabs[this.hoi - 1].checked = false;
            this.$refs.tabs.tabs[this.hoi - 2].active = false;
            this.$refs.tabs.tabs[this.hoi - 2].checked = false;
            this.$refs.tabs.tabs[this.hoi - 3].active = true;
            this.$refs.tabs.tabs[this.hoi - 3].checked = true;
            this.$refs.tabs.tabs[this.hoi - 4].active = false;
            this.$refs.tabs.tabs[this.hoi - 4].checked = true;
            this.$refs.tabs.tabs[this.hoi - 5].active = false;
            this.$refs.tabs.tabs[this.hoi - 5].checked = true;
            this.huhuhaha = 3;
            // this.huhuhaha = parseInt(e.step);
          }, 100);

          this.$emit(
            "tab-change",
            this.$refs.tabs.tabs[index - 1],
            this.$refs.tabs.tabs[index]
          );
          // let newValue = index + 1;
          this.$emit("update:startIndex", index);
        }

        if (e.step == "3") {
          // display collection schedule page
          // this.$refs.tabs.tabs[index].active = true;
          // this.$refs.tabs.tabs[index].checked = true;
          setTimeout(() => {
            this.$refs.tabs.tabs[this.hoi - 1].active = false;
            this.$refs.tabs.tabs[this.hoi - 1].checked = false;
            this.$refs.tabs.tabs[this.hoi - 2].active = true;
            this.$refs.tabs.tabs[this.hoi - 2].checked = true;
            this.$refs.tabs.tabs[this.hoi - 3].active = false;
            this.$refs.tabs.tabs[this.hoi - 3].checked = true;
            this.$refs.tabs.tabs[this.hoi - 4].active = false;
            this.$refs.tabs.tabs[this.hoi - 4].checked = true;
            this.$refs.tabs.tabs[this.hoi - 5].active = false;
            this.$refs.tabs.tabs[this.hoi - 5].checked = true;
            this.huhuhaha = 4;
          }, 100);

          this.$emit(
            "tab-change",
            this.$refs.tabs.tabs[index - 1],
            this.$refs.tabs.tabs[index]
          );
          // let newValue = index + 1;
          this.$emit("update:startIndex", index);
        }

        if (e.step == "4") {
          
          setTimeout(() => {
            this.$refs.tabs.tabs[this.hoi - 1].active = true;
            this.$refs.tabs.tabs[this.hoi - 1].checked = true;
            this.$refs.tabs.tabs[this.hoi - 2].active = false;
            this.$refs.tabs.tabs[this.hoi - 2].checked = true;
            this.$refs.tabs.tabs[this.hoi - 3].active = false;
            this.$refs.tabs.tabs[this.hoi - 3].checked = true;
            this.$refs.tabs.tabs[this.hoi - 4].active = false;
            this.$refs.tabs.tabs[this.hoi - 4].checked = true;
            this.$refs.tabs.tabs[this.hoi - 5].active = false;
            this.$refs.tabs.tabs[this.hoi - 5].checked = true;
            this.huhuhaha = 5
          }, 100);

          this.$emit(
            "tab-change",
            this.$refs.tabs.tabs[index - 1],
            this.$refs.tabs.tabs[index]
          );
          // let newValue = index + 1;
          this.$emit("update:startIndex", index);
          this.renderComponent = true;
        }

        if (e.step == "5") {
          // display collection schedule page
          // this.$refs.tabs.tabs[index].active = true;
          // this.$refs.tabs.tabs[index].checked = true;
          setTimeout(() => {
            this.$refs.tabs.tabs[this.hoi - 1].active = true;
            this.$refs.tabs.tabs[this.hoi - 1].checked = true;
            this.$refs.tabs.tabs[this.hoi - 2].active = false;
            this.$refs.tabs.tabs[this.hoi - 2].checked = true;
            this.$refs.tabs.tabs[this.hoi - 3].active = false;
            this.$refs.tabs.tabs[this.hoi - 3].checked = true;
            this.$refs.tabs.tabs[this.hoi - 4].active = false;
            this.$refs.tabs.tabs[this.hoi - 4].checked = true;
            this.$refs.tabs.tabs[this.hoi - 5].active = false;
            this.$refs.tabs.tabs[this.hoi - 5].checked = true;
            this.huhuhaha = 6
          }, 100);

          this.$emit(
            "tab-change",
            this.$refs.tabs.tabs[index - 1],
            this.$refs.tabs.tabs[index]
          );
          // let newValue = index + 1;
          this.$emit("update:startIndex", index);
        }

    

        // if (e.step == "7") {
        //   // display collection schedule page

        //   this.$refs.tabs.tabs[index].active = true;
        //   this.$refs.tabs.tabs[index].checked = true;
        //   console.log(this.$refs.tabs.tabs[index].active);
        //   setTimeout(() => {
        //     this.$refs.tabs.tabs[index - 1].active = false;
        //     this.$refs.tabs.tabs[index - 1].checked = true;
        //     this.$refs.tabs.tabs[index - 2].active = false;
        //     this.$refs.tabs.tabs[index - 2].checked = true;
        //     this.$refs.tabs.tabs[index - 3].active = false;
        //     this.$refs.tabs.tabs[index - 3].checked = true;
        //     this.$refs.tabs.tabs[index - 4].active = false;
        //     this.$refs.tabs.tabs[index - 4].checked = true;
        //     this.$refs.tabs.tabs[index - 5].active = false;
        //     this.$refs.tabs.tabs[index - 5].checked = true;
        //     this.$refs.tabs.tabs[index - 6].active = false;
        //     this.$refs.tabs.tabs[index - 6].checked = true;
        //     this.$refs.tabs.tabs[index - 7].active = false;
        //     this.$refs.tabs.tabs[index - 7].checked = true;
        //     this.huhuhaha = parseInt(e.step);
        //   }, 100);

        //   this.$emit(
        //     "tab-change",
        //     this.$refs.tabs.tabs[index - 1],
        //     this.$refs.tabs.tabs[index]
        //   );
        //   // let newValue = index + 1;
        //   this.$emit("update:startIndex", index);
        //   console.log(this.$refs.tabs);
        // }
      }

      if (e.direction == "blkg") {
        if (e.step == "1") {
          this.getBack();
        }

        if (e.step == "2") {
          // display ANF
          this.$refs.tabs.tabs[this.hoi - 1].active = false;
            this.$refs.tabs.tabs[this.hoi - 1].checked = false;
            this.$refs.tabs.tabs[this.hoi - 2].active = false;
            this.$refs.tabs.tabs[this.hoi - 2].checked = false;
            this.$refs.tabs.tabs[this.hoi - 3].active = false;
            this.$refs.tabs.tabs[this.hoi - 3].checked = false;
            this.$refs.tabs.tabs[this.hoi - 4].active = false;
            this.$refs.tabs.tabs[this.hoi - 4].checked = false;
            this.$refs.tabs.tabs[this.hoi - 5].active = true;
            this.$refs.tabs.tabs[this.hoi - 5].checked = true;
          this.huhuhaha = parseInt(e.step) - 1;

          this.$emit(
            "tab-change",
            this.$refs.tabs.tabs[index - 1],
            this.$refs.tabs.tabs[index]
          );
          let newValue = index + 1;
          this.$emit("update:startIndex", newValue);
        }

        if (e.step == "3") {
          // display quotation

          this.$refs.tabs.tabs[this.hoi - 1].active = false;
            this.$refs.tabs.tabs[this.hoi - 1].checked = false;
            this.$refs.tabs.tabs[this.hoi - 2].active = false;
            this.$refs.tabs.tabs[this.hoi - 2].checked = false;
            this.$refs.tabs.tabs[this.hoi - 3].active = false;
            this.$refs.tabs.tabs[this.hoi - 3].checked = false;
            this.$refs.tabs.tabs[this.hoi - 4].active = true;
            this.$refs.tabs.tabs[this.hoi - 4].checked = true;
            this.$refs.tabs.tabs[this.hoi - 5].active = false;
            this.$refs.tabs.tabs[this.hoi - 5].checked = true;
            this.huhuhaha = parseInt(e.step) - 1;

          this.$emit(
            "tab-change",
            this.$refs.tabs.tabs[index - 1],
            this.$refs.tabs.tabs[index]
          );
          let newValue = index + 1;
          this.$emit("update:startIndex", newValue);
        }

        if (e.step == "4") {
          console.log("belakang 4");
          setTimeout(() => {
            this.$refs.tabs.tabs[this.hoi - 1].active = false;
            this.$refs.tabs.tabs[this.hoi - 1].checked = false;
            this.$refs.tabs.tabs[this.hoi - 2].active = false;
            this.$refs.tabs.tabs[this.hoi - 2].checked = false;
            this.$refs.tabs.tabs[this.hoi - 3].active = true;
            this.$refs.tabs.tabs[this.hoi - 3].checked = true;
            this.$refs.tabs.tabs[this.hoi - 4].active = false;
            this.$refs.tabs.tabs[this.hoi - 4].checked = true;
            this.$refs.tabs.tabs[this.hoi - 5].active = false;
            this.$refs.tabs.tabs[this.hoi - 5].checked = true;
            
            this.huhuhaha = parseInt(e.step) - 1;
          }, 100);

          this.$emit(
            "tab-change",
            this.$refs.tabs.tabs[index - 1],
            this.$refs.tabs.tabs[index]
          );
          let newValue = index + 1;
          this.$emit("update:startIndex", newValue);
        }

        if (e.step == "5") {
          

          setTimeout(() => {
            this.$refs.tabs.tabs[this.hoi - 1].active = false;
            this.$refs.tabs.tabs[this.hoi - 1].checked = false;
            this.$refs.tabs.tabs[this.hoi - 2].active = true;
            this.$refs.tabs.tabs[this.hoi - 2].checked = true;
            this.$refs.tabs.tabs[this.hoi - 3].active = false;
            this.$refs.tabs.tabs[this.hoi - 3].checked = true;
            this.$refs.tabs.tabs[this.hoi - 4].active = false;
            this.$refs.tabs.tabs[this.hoi - 4].checked = true;
            this.$refs.tabs.tabs[this.hoi - 5].active = false;
            this.$refs.tabs.tabs[this.hoi - 5].checked = true;
            this.huhuhaha = parseInt(e.step) - 1;
          }, 100);

          this.$emit(
            "tab-change",
            this.$refs.tabs.tabs[index - 1],
            this.$refs.tabs.tabs[index]
          );

          this.$emit("update:startIndex", index);
        }

        

       
    
      }

      // setTimeout(() => {
        this.flag = true
        console.log("executed!!")
        this.forceRerender()
      // }, 500)
     
    },
    getBack() {
      this.$router.push("/Incoming");
    },
    validateStep(ref) {
      return this.$refs[ref].validate();
    },
    validate(tab) {
      let tabToValidate = tab || this.activeTab;

      let beforeChange = tabToValidate.beforeChange;
      if (beforeChange) {
        return Promise.resolve(beforeChange())
          .then((res) => {
            this.activeTab.hasError = res ? false : true;
            return res;
          })
          .catch(() => {
            this.activeTab.hasError = true;
          });
      } else {
        return Promise.resolve(true);
      }
    },
    onStepValidated(validated, model) {
      this.wizardModel = { ...this.wizardModel, ...model };
    },
    wizardComplete() {
      swal("Good job!", "You clicked the finish button!", "success");
    },
  },
};
</script>
